import React from 'react';
import { Skeleton } from "@material-ui/lab";

  export const SkeletonCard = () => (
    <div>
      <Skeleton style={{ marginBottom: 10 }} animation="wave" variant="rect" width={'20vw'} height={400} />
    </div>
  );